





















































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import ConfirmDialog from '@/components/shared/ConfirmDialog.vue'
import { CustomData } from '@/libs/palletPattern'

@Component({
  components: {ConfirmDialog}
})
export default class CustomDataDialog extends Vue {
  @Prop() private value: boolean = false
  @Prop({required: true}) private customData!: CustomData[]
  private tempCustomData: CustomData[] = JSON.parse(JSON.stringify(this.customData))

  get show() {
    return this.value
  }

  set show(value) {
    this.$emit('input', value)
  }

  private localText(arg: string, values?: string[]): string {
    return String(this.$t(arg, values))
  }

  private isSaveDisabled(): boolean {
    const sortedCustomData = [...this.customData].sort()
    const sortedCustomDataTemp = [...(this.tempCustomData.filter(c => c.key !== ''))].sort()
    return JSON.stringify(sortedCustomData) === JSON.stringify(sortedCustomDataTemp) ||
        (sortedCustomData.length === 0 && sortedCustomDataTemp.length === 0)
  }

  private cancel() {
    this.tempCustomData =  JSON.parse(JSON.stringify(this.customData))
    this.$emit('cancel')
  }

  private save() {
    const skipConfirmDialog = this.customData.length === 0 && this.tempCustomData.length > 0
    this.customData =  this.tempCustomData
    const cData = this.customData.filter(c => c.key !== '').reduce((acc, item) => {
      acc[item.key] = item.value
      return acc
    }, {} as { [key: string]: any })
    this.$emit('save', cData, skipConfirmDialog)
  }

  private remove(index: number) {
    this.tempCustomData.splice(index, 1)
  }

  private add() {
    this.tempCustomData = [...this.tempCustomData, {key: '', value: null}]
    this.$nextTick(() => {
      const index = this.tempCustomData.length - 1
      const refName = 'input-key-' + index
      const input = this.$refs[refName]
      if (Array.isArray(input)) {
        const first = input[0] as Vue & { focus: () => void }
        first.focus()
      } else if (input && 'focus' in input) {
        (input as any).focus()
      }
    })
  }

  @Watch('value')
  private valueWatcher() {
    this.tempCustomData = JSON.parse(JSON.stringify(this.customData))
  }
}
